module.exports = __webpack_public_path__ + "img/94615B_DACED1_C3B9A4_CCABAA-256px.1275b76b.png";